import { type ReactNode, useState } from 'react';

import { AdvisorContext, type AdvisorInfo } from './advisorContextValue';

export function AdvisorProvider({ children }: { children: ReactNode }) {
  const [advisor, setAdvisor] = useState<AdvisorInfo>(null);

  const clearAdvisor = () => setAdvisor(null);

  const hasAdvisor = advisor !== null;

  const advisorDisplayName = advisor
    ? `${advisor.firstName} ${advisor.lastName}`.trim() || 'Your Advisor'
    : 'Your Advisor';

  return (
    <AdvisorContext.Provider
      value={{
        advisor,
        setAdvisor,
        clearAdvisor,
        hasAdvisor,
        advisorDisplayName,
      }}
    >
      {children}
    </AdvisorContext.Provider>
  );
}
